module.exports = __webpack_public_path__ + "img/紫底横_logo_name.c37981ca.png";